"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var SymbolicSpace_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolicSpace = void 0;
const core_1 = require("@openhps/core");
const AbstractLocation_1 = require("./AbstractLocation");
const wkt = require('wkt');
let SymbolicSpace = SymbolicSpace_1 = class SymbolicSpace extends core_1.ReferenceSpace {
    constructor(displayName) {
        super();
        this.coordinates = [];
        this.connectedSpaces = new Map();
        this.priority = 0;
        this.displayName = displayName;
    }
    get boundaryType() {
        return this.positionConstructor;
    }
    setBounds(bounds) {
        if (Array.isArray(bounds)) {
            this.setArrayBounds(bounds);
        }
        else if ('topLeft' in bounds) {
            this.setRectangleBounds(bounds);
        }
        this.updateCentroid();
        return this;
    }
    setRectangleBounds(bounds) {
        if ('width' in bounds) {
            const topLeft = bounds.topLeft;
            const eulerRotation = new core_1.Euler(0, 0, bounds.rotation, 'XYZ', core_1.AngleUnit.DEGREE);
            this.rotation(eulerRotation);
            const boundsArray = [];
            if (topLeft instanceof core_1.GeographicalPosition) {
                const topRight = topLeft.destination(bounds.rotation, bounds.width);
                const bottomLeft = topLeft.destination(bounds.rotation + 90, bounds.length);
                const bottomRight = topRight.destination(bounds.rotation + 90, bounds.length);
                boundsArray.push(topLeft);
                boundsArray.push(topRight);
                boundsArray.push(bottomRight);
                boundsArray.push(bottomLeft);
                boundsArray.push(topLeft);
                this.origin = bottomLeft.clone();
            }
            else {
                const topRight = topLeft
                    .toVector3(core_1.LengthUnit.METER)
                    .add(new core_1.Vector3(bounds.width, 0, 0).applyEuler(eulerRotation));
                const bottomLeft = topLeft
                    .toVector3(core_1.LengthUnit.METER)
                    .add(new core_1.Vector3(0, bounds.length, 0).applyEuler(eulerRotation));
                const bottomRight = topLeft
                    .toVector3(core_1.LengthUnit.METER)
                    .add(new core_1.Vector3(bounds.width, bounds.length, 0).applyEuler(eulerRotation));
                boundsArray.push(topLeft);
                boundsArray.push(topLeft.clone().fromVector(topRight, core_1.LengthUnit.METER));
                boundsArray.push(topLeft.clone().fromVector(bottomRight, core_1.LengthUnit.METER));
                boundsArray.push(topLeft.clone().fromVector(bottomLeft, core_1.LengthUnit.METER));
                boundsArray.push(topLeft);
                this.origin = new this.positionConstructor();
                this.origin.fromVector(bottomLeft.clone());
            }
            if (bounds.height) {
                boundsArray.forEach((bound) => {
                    const boundUp = bound.clone();
                    boundUp.z = boundUp.z + bounds.height;
                    boundsArray.push(boundUp);
                });
            }
            this.setArrayBounds(boundsArray);
        }
        else {
            this.setArrayBounds([bounds.topLeft, bounds.bottomRight]);
        }
    }
    setArrayBounds(bounds) {
        this.positionConstructor = bounds[0].constructor;
        const points = bounds.map((bound) => bound.toVector3(core_1.LengthUnit.METER));
        if (bounds.length === 2) {
            const topLeft = points[0];
            const bottomRight = points[1];
            const diff = bottomRight.clone().sub(topLeft);
            const zCount = points.map((p) => p.z).reduce((a, b) => a + b);
            if (zCount !== 0) {
                this.coordinates.push(topLeft);
                this.coordinates.push(topLeft.clone().add(new core_1.Vector3(diff.x, 0, 0)));
                this.coordinates.push(topLeft.clone().add(new core_1.Vector3(diff.x, diff.y, 0)));
                const bottomLeft = topLeft.clone().add(new core_1.Vector3(0, diff.y, 0));
                this.coordinates.push(bottomLeft);
                this.origin = new this.positionConstructor();
                this.origin.fromVector(bottomLeft.clone());
                this.coordinates.push(topLeft.clone().add(new core_1.Vector3(0, 0, diff.z)));
                this.coordinates.push(topLeft.clone().add(new core_1.Vector3(diff.x, 0, diff.z)));
                this.coordinates.push(bottomRight);
                this.coordinates.push(topLeft.clone().add(new core_1.Vector3(0, diff.y, diff.z)));
                this.coordinates.push(topLeft);
            }
            else {
                this.coordinates.push(topLeft);
                this.coordinates.push(topLeft.clone().add(new core_1.Vector3(diff.x, 0, 0)));
                this.coordinates.push(bottomRight);
                const bottomLeft = topLeft.clone().add(new core_1.Vector3(0, diff.y, 0));
                this.origin = new this.positionConstructor();
                this.origin.fromVector(bottomLeft.clone());
                this.coordinates.push(bottomLeft);
                this.coordinates.push(topLeft);
            }
        }
        else {
            this.coordinates = points;
            if (this.coordinates[0].toArray() !== this.coordinates[this.coordinates.length - 1].toArray()) {
                this.coordinates.push(this.coordinates[0]);
            }
        }
    }
    getBounds() {
        return this.coordinates.map((point) => {
            const position = new this.positionConstructor();
            position.fromVector(point, core_1.LengthUnit.METER);
            return position;
        });
    }
    updateCentroid() {
        this.centroid = new this.positionConstructor();
        this.centroid.referenceSpaceUID = this.uid;
        const filteredCoordinates = this.coordinates.filter((e, i) => this.coordinates.indexOf(e) === i);
        const centerPoint = filteredCoordinates
            .reduce((a, b) => a.clone().add(b))
            .divideScalar(filteredCoordinates.length);
        this.centroid.fromVector(centerPoint, core_1.LengthUnit.METER);
    }
    set parent(loc) {
        super.parent = loc;
    }
    get parent() {
        return super.parent;
    }
    isInside(position) {
        const transformedPosition = position instanceof this.positionConstructor ? position : this.transform(position);
        const isGeo = position instanceof core_1.GeographicalPosition;
        const point = isGeo ? transformedPosition.toVector3() : transformedPosition.toVector3(core_1.LengthUnit.METER);
        let coordinates = this.coordinates;
        if (isGeo) {
            const bounds = this.getBounds();
            if (this.positionConstructor.name === core_1.GeographicalPosition.name) {
                coordinates = bounds.map((pos) => pos.toVector3());
            }
            else {
                coordinates = bounds.map((pos) => this.transform(pos)).map((pos) => pos.toVector3());
            }
        }
        const zSorted = coordinates.map((c) => c.z).sort((a, b) => a - b);
        const minZ = zSorted[0];
        const maxZ = zSorted[zSorted.length - 1];
        if (minZ !== maxZ) {
            coordinates = coordinates.filter((c) => Math.round(c.z) === Math.round(minZ));
        }
        return (this._rayCasting([point.x, point.y], coordinates.map((c) => [c.x, c.y])) &&
            point.z >= minZ &&
            point.z <= maxZ);
    }
    _rayCasting(point, polygon) {
        const n = polygon.length;
        if (n === 0) {
            return false;
        }
        let isIn = false;
        const x = point[0];
        const y = point[1];
        let x1, x2, y1, y2;
        x1 = polygon[n - 1][0];
        y1 = polygon[n - 1][1];
        for (let i = 0; i < n; ++i) {
            x2 = polygon[i][0];
            y2 = polygon[i][1];
            if (y < y1 !== y < y2 && x < ((x2 - x1) * (y - y1)) / (y2 - y1) + x1) {
                isIn = !isIn;
            }
            x1 = x2;
            y1 = y2;
        }
        return isIn;
    }
    isConnected(space) {
        return Array.from(this.connectedSpaces.values()).includes(space.uid);
    }
    addConnectedSpace(space, position) {
        this.connectedSpaces.set(position.toVector3(), space.uid);
        return this;
    }
    toPosition() {
        const centroid = this.centroid;
        const centroidVector = centroid.toVector3(core_1.LengthUnit.METER);
        const maxDistance = this.coordinates.map((coord) => centroidVector.distanceTo(coord)).sort((a, b) => a - b)[0];
        centroid.accuracy = new core_1.Accuracy1D(maxDistance, core_1.LengthUnit.METER);
        return centroid;
    }
    static fromGeoJSON(json) {
        if (!json) {
            return undefined;
        }
        if (!json.properties) {
            json.properties = {};
        }
        let instance = undefined;
        if (json.properties.type) {
            const dataType = core_1.DataSerializer.findTypeByName(json.properties.type);
            instance = new dataType();
        }
        else {
            instance = new SymbolicSpace_1();
        }
        instance.uid = json.properties.uid;
        instance.parentUID = json.properties.parent_uid;
        instance.priority = json.properties.priority;
        instance.displayName = json.properties.name;
        if (json.properties.transformationMatrix) {
            instance.transformationMatrix.elements = json.properties.transformationMatrix;
        }
        if (json.properties.translationMatrix) {
            instance.translationMatrix.elements = json.properties.translationMatrix;
        }
        if (json.properties.scaleMatrix) {
            instance.scaleMatrix.elements = json.properties.scaleMatrix;
        }
        if (json.properties.rotationQuaternion) {
            instance.rotationQuaternion = new core_1.Quaternion(...json.properties.rotationQuaternion);
        }
        instance.coordinates = (json.geometry && json.geometry.coordinates ? json.geometry.coordinates : json.coordinates)[0].map((pos) => {
            const position = new core_1.GeographicalPosition();
            position.x = pos[0];
            position.y = pos[1];
            position.z = pos[2];
            return position.toVector3(core_1.LengthUnit.METER);
        });
        const origin = new core_1.GeographicalPosition();
        switch (instance.coordinates.length) {
            case 5:
            case 11:
            case 9:
                origin.fromVector(instance.coordinates[3], core_1.LengthUnit.METER);
                instance.origin = origin;
                break;
        }
        instance.positionConstructor = core_1.GeographicalPosition;
        instance.updateCentroid();
        return instance;
    }
    static fromWKT(wktLiteral) {
        const geojson = wkt.parse(wktLiteral);
        if (!geojson) {
            throw new Error(`Unable to deserialize well-known text for ${wktLiteral}`);
        }
        return this.fromGeoJSON(geojson);
    }
    toGeoJSON(flat) {
        const avgZ = this.getBounds()
            .map((b) => b.toVector3().z)
            .reduce((a, b) => a + b) / this.getBounds().length;
        const coordinates = this.getBounds()
            .filter((p) => (flat ? !(p.toVector3().z > avgZ) : true))
            .map((pos) => (pos instanceof core_1.GeographicalPosition ? pos : this.transform(pos)))
            .map((p) => p.toVector3().toArray())
            .map((p) => (flat ? [p[0], p[1]] : p));
        return {
            type: 'Feature',
            geometry: {
                type: 'Polygon',
                coordinates: [coordinates],
            },
            properties: {
                name: this.displayName,
                uid: this.uid,
                parent_uid: this.parentUID,
                priority: this.priority,
                type: this.constructor.name,
                transformationMatrix: this.transformationMatrix.elements,
                rotationQuaternion: [
                    this.rotationQuaternion.x,
                    this.rotationQuaternion.y,
                    this.rotationQuaternion.z,
                    this.rotationQuaternion.w,
                ],
                scaleMatrix: this.scaleMatrix.elements,
                translationMatrix: this.translationMatrix.elements,
                boundaryType: this.positionConstructor.name,
                origin: this.origin ? this.origin.toVector3(core_1.LengthUnit.METER).toArray() : undefined,
            },
        };
    }
    toWKT() {
        return wkt.stringify(this.toGeoJSON());
    }
    toLocation() {
        return new AbstractLocation_1.AbstractLocation(this.uid, 100);
    }
};
exports.SymbolicSpace = SymbolicSpace;
__decorate([
    (0, core_1.SerializableArrayMember)(core_1.Vector3),
    __metadata("design:type", Array)
], SymbolicSpace.prototype, "coordinates", void 0);
__decorate([
    (0, core_1.SerializableMember)({
        serializer: (constructor) => {
            if (!constructor) {
                return core_1.AbsolutePosition.name;
            }
            return constructor.name;
        },
        deserializer: (constructorName) => {
            return core_1.DataSerializer.findTypeByName(constructorName);
        },
    }),
    __metadata("design:type", Function)
], SymbolicSpace.prototype, "positionConstructor", void 0);
__decorate([
    (0, core_1.SerializableMember)(),
    __metadata("design:type", core_1.AbsolutePosition)
], SymbolicSpace.prototype, "centroid", void 0);
__decorate([
    (0, core_1.SerializableMapMember)(core_1.Vector3, String),
    __metadata("design:type", Map)
], SymbolicSpace.prototype, "connectedSpaces", void 0);
__decorate([
    (0, core_1.SerializableMember)({
        constructor: Number,
    }),
    __metadata("design:type", Object)
], SymbolicSpace.prototype, "priority", void 0);
__decorate([
    (0, core_1.SerializableMember)(),
    __metadata("design:type", core_1.AbsolutePosition)
], SymbolicSpace.prototype, "origin", void 0);
exports.SymbolicSpace = SymbolicSpace = SymbolicSpace_1 = __decorate([
    (0, core_1.SerializableObject)(),
    __metadata("design:paramtypes", [String])
], SymbolicSpace);
//# sourceMappingURL=SymbolicSpace.js.map